<template>
    <v-container fluid>
        <v-layout column align-center>

            <v-snackbar
                    v-model="snackbar"
                    color="warning"
                    :multi-line="false"
                    :timeout="4000"
                    :top="true"
                    :vertical="false"
            >
                For mange bogstaver, kun 6 bogstaver!
                <v-btn
                        dark
                        flat
                        @click="snackbar = false"
                >
                    Close
                </v-btn>
            </v-snackbar>

            <h1>Ruko Garant 10</h1>

            <v-form>
                <v-text-field
                        v-model="string"
                        label="Input"
                        :readonly="true"
                ></v-text-field>
                <v-text-field
                        v-model="result"
                        label="Result"
                        :readonly="true"
                ></v-text-field>

                <v-btn dark block color="indigo" @click="resetString">
                    Nulstil
                </v-btn>

                <div class="text-xs-center">
                    <v-btn fab dark color="indigo" @click="appendLetter('A')">
                        A
                    </v-btn>
                    <v-btn fab dark color="indigo" @click="appendLetter('B')">
                        B
                    </v-btn>
                    <v-btn fab dark color="indigo" @click="appendLetter('C')">
                        C
                    </v-btn>
                    <v-btn fab dark color="indigo" @click="appendLetter('D')">
                        D
                    </v-btn>
                    <v-btn fab dark color="indigo" @click="appendLetter('E')">
                        E
                    </v-btn>
                    <v-btn fab dark color="indigo" @click="appendLetter('F')">
                        F
                    </v-btn>
                    <v-btn fab dark color="indigo" @click="appendLetter('G')">
                        G
                    </v-btn>
                    <v-btn fab dark color="indigo" @click="appendLetter('H')">
                        H
                    </v-btn>
                    <v-btn fab dark color="indigo" @click="appendLetter('J')">
                        J
                    </v-btn>
                </div>
            </v-form>


        </v-layout>
    </v-container>
</template>

<script>
    export default {
        name: 'RukoGarantTen',
        data() {
            return {
                string: '',
                snackbar: false,
                positionMatrix: {
                    '0': {
                        E: 1,
                        J: 2,
                        F: 3,
                        C: 4,
                        D: 5,
                        B: 6,
                        H: 7,
                        G: 8,
                        A: 9,
                    },
                    '1': {
                        F: 1,
                        A: 2,
                        C: 3,
                        H: 4,
                        G: 5,
                        D: 6,
                        B: 7,
                        J: 8,
                        E: 9,
                    },
                    '2': {
                        J: 1,
                        B: 2,
                        D: 3,
                        A: 4,
                        F: 5,
                        E: 6,
                        G: 7,
                        H: 8,
                        C: 9,
                    },
                    '3': {
                        B: 1,
                        C: 2,
                        J: 3,
                        D: 4,
                        E: 5,
                        H: 6,
                        F: 7,
                        A: 8,
                        G: 9,
                    },
                    '4': {
                        G: 1,
                        D: 2,
                        H: 3,
                        B: 4,
                        J: 5,
                        A: 6,
                        C: 7,
                        E: 8,
                        F: 9,
                    },
                    '5': {
                        A: 1,
                        F: 2,
                        E: 3,
                        J: 4,
                        H: 5,
                        G: 6,
                        D: 7,
                        C: 8,
                        B: 9,
                    },
                }
            }
        },
        methods: {
            resetString() {
                this.string = '';
            },
            appendLetter(letter) {
                if (this.string.length < 6) {
                    this.string = this.string + letter;
                } else {
                    this.snackbar = true;
                }
            }
        },
        computed: {
            result() {

                let result = '';
                let value = this.string;
                for (let i = 0; i < value.length; i++) {

                    let letter = value.charAt(i);

                    result = result + this.positionMatrix[i][letter];

                }
                return result;
            }
        }
    }
</script>